import { render, staticRenderFns } from "./doorCode.vue?vue&type=template&id=23585f23"
import script from "./doorCode.vue?vue&type=script&lang=js"
export * from "./doorCode.vue?vue&type=script&lang=js"
import style0 from "./doorCode.vue?vue&type=style&index=0&id=23585f23&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports